import moment from 'moment-timezone';

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_DISPLAY = 'dd/MM/yyyy';
export const DATETIME_FORMAT_DISPLAY = 'dd/MM/yyyy HH:mm:ss';

export function formatCurrentDateYYYYMMDDTHHmmss() {
  return moment().format('YYYY-MM-DDTHH:mm:ss');
}

export function formatDateDDmm(date) {
  return moment(date, 'YYYY-MM-DD').format('DD/MM');
}

export function formatDateRangeDDmm(initDate, endDate, options = {}) {
  const { sameDayFormatter, rangeFormatter } = options;
  const from = moment(initDate, 'YYYY-MM-DD', true);
  const to = moment(endDate, 'YYYY-MM-DD', true);

  if (!from.isValid() || !to.isValid()) {
    return '';
  }

  const formattedFrom = from.format('DD/MM');
  const formattedTo = to.format('DD/MM');

  if (from.isSame(to, 'day')) {
    return sameDayFormatter ? sameDayFormatter(formattedFrom) : formattedFrom;
  }

  return rangeFormatter ? rangeFormatter(formattedFrom, formattedTo) : `${formattedFrom} - ${formattedTo}`;
}

export function formatDateDDmmm(date) {
  return moment(date, 'YYYY-MM-DD').format('DD MMM');
}

export function formatDateDDmmmm(date) {
  return moment(date, 'YYYY-MM-DD').format('DD MMMM');
}

export function formatDateDDmmmmYYYY(date) {
  return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
}

export function formatDateIntervalDDmmm(initDate, endDate) {
  const from = moment(initDate, 'YYYY-MM-DD');
  const to = moment(endDate, 'YYYY-MM-DD');

  return `${from.format('DD MMM')} - ${to.format('DD MMM')}`;
}

export function formatDateDDmmmYYYY(date) {
  return moment(date, 'YYYY-MM-DD').format('ll');
}

export function fomatDatesHyphen(date) {
  return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
}

export function formatDate(date) {
  return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
}

export function formatDateDDMMYYYY(date, timezone) {
  if (!date) return '';
  const dateMoment = timezone ? moment.tz(date, timezone) : moment(date);
  if (!dateMoment.isValid()) return '';
  return dateMoment.format('DD/MM/YYYY');
}

export function formatTimeHHmm(date, timezone) {
  if (!date) return '';
  const dateMoment = timezone ? moment.tz(date, timezone) : moment(date);
  if (!dateMoment.isValid()) return '';
  return dateMoment.format('HH:mm');
}

export function fomatDatesHyphenPost(date) {
  return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
}

export function formatDateWithWeekDay(date) {
  return moment(date, 'YYYY-MM-DD').format('ddd, D MMM');
}

export function normalizeDate(dateString) {
  return moment(dateString).startOf('day');
}

export function normalizeRango(fechaInicio, fechaFin) {
  return {
    fechaInicio: moment(fechaInicio, ISO_DATE_FORMAT).format(ISO_DATE_FORMAT),
    fechaFin: moment(fechaFin, ISO_DATE_FORMAT).format(ISO_DATE_FORMAT),
  };
}

export function normalizeFromToDates(start, end) {
  const from = moment(start, 'YYYY-MM-DD');
  const to = moment(end, 'YYYY-MM-DD');

  if (from.isSame(to, 'day')) {
    return from.format('DD MMM');
  }

  if (from.month() === to.month()) {
    return `${from.format('DD')} - ${to.format('DD MMM')}`;
  }

  return `${from.format('DD MMM')} - ${to.format('DD MMM')}`;
}

export function millisecondsBetween(inicio, fin) {
  return moment(fin).diff(moment(inicio), 'milliseconds');
}

export function calcularEdad(fechaNacimiento) {
  const hoy = moment();
  const nacimiento = moment(fechaNacimiento);
  return hoy.diff(nacimiento, 'years');
}

export function normalizeDateYYYYMMDD(fecha) {
  if (!fecha) return null;

  if (fecha.length === 10 && fecha[2] === '-' && fecha[5] === '-') {
    const [day, month, year] = fecha.split('-');
    return `${year}-${month}-${day}`;
  }

  if (fecha.length === 10 && fecha[4] === '-' && fecha[7] === '-') {
    return fecha;
  }

  const parsed = moment(fecha);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
}

export function isBeforeToday(date) {
  const normalized = normalizeDateYYYYMMDD(date);
  if (!normalized) return false;

  return moment(normalized, 'YYYY-MM-DD').isBefore(moment(), 'day');
}
